"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../button/Button");
var _Private24PxOutlined = _interopRequireDefault(require("../icons-jb/Private24PxOutlined"));
var _Visible24PxOutlined = _interopRequireDefault(require("../icons-jb/Visible24PxOutlined"));
var _Input = _interopRequireDefault(require("../input/Input"));
var _inputPasswordModule = _interopRequireDefault(require("./input-password.module.scss"));
var _PasswordRules = _interopRequireDefault(require("./password-rules/PasswordRules"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InputPassword = /*#__PURE__*/function (_PureComponent) {
  function InputPassword(props) {
    var _this;
    _classCallCheck(this, InputPassword);
    _this = _callSuper(this, InputPassword, [props]);
    _defineProperty(_this, "onFocus", function (evt) {
      var onFocus = _this.props.onFocus;

      // pass event through to redux-form
      onFocus(evt);
    });
    _defineProperty(_this, "handleToggle", function () {
      _this.setState({
        showPasswordValue: !_this.state.showPasswordValue
      });
    });
    _this.state = {
      showPasswordValue: false
    };
    return _this;
  }
  _inherits(InputPassword, _PureComponent);
  return _createClass(InputPassword, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        meta = _this$props.meta,
        passwordRules = _this$props.passwordRules,
        passwordToggle = _this$props.passwordToggle,
        extensionProps = _this$props.extensionProps,
        passwordRulesMaxLength = _this$props.passwordRulesMaxLength;
      var showPasswordValue = this.state.showPasswordValue;
      var showPasswordToggleButton = passwordToggle && (meta.active || meta.touched || (value === null || value === void 0 ? void 0 : value.length) >= 1);
      var getInputType = function getInputType() {
        if (passwordToggle) {
          return showPasswordValue ? 'text' : 'password';
        }
        return 'password';
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _inputPasswordModule["default"].inputWrapper,
        "data-jlds": true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Input["default"], _objectSpread(_objectSpread({}, this.props), {}, {
          extensionProps: _objectSpread({
            type: getInputType(),
            autoComplete: 'off',
            onFocus: this.onFocus
          }, extensionProps)
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnderlinedButton, {
          onClick: this.handleToggle,
          disabled: !showPasswordToggleButton,
          className: (0, _classnames["default"])(_inputPasswordModule["default"].toggleButton),
          children: showPasswordValue ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Private24PxOutlined["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: "Hide password"
            })]
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Visible24PxOutlined["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: "Show password"
            })]
          })
        }), passwordRules && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordRules["default"], {
          value: value,
          touched: meta.touched,
          maxLength: passwordRulesMaxLength
        })]
      });
    }
  }]);
}(_react.PureComponent);
_defineProperty(InputPassword, "propTypes", _objectSpread(_objectSpread({}, _Input["default"].propTypes), {}, {
  meta: _propTypes["default"].shape({
    active: _propTypes["default"].bool,
    touched: _propTypes["default"].bool
  }),
  passwordRules: _propTypes["default"].bool,
  passwordToggle: _propTypes["default"].bool,
  passwordRulesMaxLength: _propTypes["default"].number
}));
_defineProperty(InputPassword, "defaultProps", _objectSpread(_objectSpread({}, _Input["default"].defaultProps), {}, {
  meta: {},
  passwordRules: false,
  passwordToggle: false,
  passwordRulesMaxLength: 20
}));
var _default = exports["default"] = InputPassword;